module.exports = __webpack_public_path__ + "static/media/logo-outline-fa.0016a205.svg";